import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Layout components
import Navbar from "../Components/Navbar/Navbar";
import Footer from "../Components/Footer/Footer";

// Public pages
import Shop from "../Pages/Shop";
import Cart from "../Pages/Cart";
import Product from "../Pages/Product";
import ShopCategory from "../Pages/ShopCategory";
import LoginSignup from "../Pages/LoginSignup";
import UserProfile from "../Pages/UserProfile";

// Admin pages
import AdminPanel from "../admin/AdminPanel";
import AdminDashboard from "../admin/AdminDashboard";
import AdminAddProduct from "../admin/AdminAddProduct";
import AdminListProduct from "../admin/AdminListProduct";
import AdminUsers from "../admin/AdminUsers";
import AdminOrders from "../admin/AdminOrders";
import AdminPayments from "../admin/AdminPayments";
import AdminReviews from "../admin/AdminReviews";
import AdminCoupons from "../admin/AdminCoupons";
import AdminManagement from "../admin/AdminManagement";
import AdminSettings from "../admin/AdminSettings";
import AdminHomePage from "../admin/AdminHomePage";
import AdminCategories from "../admin/AdminCategories";

const AppRoutes = () => {
  return (
    <Routes>
      {/* ── Admin routes (no Navbar / Footer) ─────────────────────────── */}
      <Route path="/admin" element={<AdminPanel />}>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard"   element={<AdminDashboard />} />
        <Route path="addproduct"  element={<AdminAddProduct />} />
        <Route path="categories"  element={<AdminCategories />} />
        <Route path="listproduct" element={<AdminListProduct />} />
        <Route path="users"       element={<AdminUsers />} />
        <Route path="orders"      element={<AdminOrders />} />
        <Route path="payments"    element={<AdminPayments />} />
        <Route path="reviews"     element={<AdminReviews />} />
        <Route path="coupons"     element={<AdminCoupons />} />
        <Route path="management"  element={<AdminManagement />} />
        <Route path="settings"    element={<AdminSettings />} />
        <Route path="homepage"    element={<AdminHomePage />} />
      </Route>

      {/* ── Public routes (with Navbar / Footer) ──────────────────────── */}
      <Route
        path="/*"
        element={
          <>
            <Navbar />
            <Routes>
              <Route path="/"            element={<Shop gender="all" />} />
              <Route path="/category/:categorySlug" element={<ShopCategory />} />
              <Route path="/laptops"     element={<Navigate to="/category/laptops" replace />} />
              <Route path="/mobiles"     element={<Navigate to="/category/mobiles" replace />} />
              <Route path="/phones"      element={<Navigate to="/category/mobiles" replace />} />
              <Route path="/accessories" element={<Navigate to="/category/accessories" replace />} />
              <Route path="/product"     element={<Product />}>
                <Route path=":productId" element={<Product />} />
              </Route>
              <Route path="/cart"        element={<Cart />} />
              <Route path="/login"       element={<LoginSignup />} />
              <Route path="/profile"     element={<UserProfile />} />
            </Routes>
            <Footer />
          </>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
